<div class="custom-dialog">
  <h4 class="dialog-header">Cookie Einstellungen</h4>
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h3>
          Wir verwenden Cookies ...
        </h3>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 max-width-container">
        <div class="cookie-info-text">...um für Sie unser Kundenportal MEINE NV so benutzerfreundlich wie möglich zu
          gestalten. Für eine technisch uneingeschränkte und sichere
          Nutzung unseres Kundenportals werden <span class="bold">notwendige Cookies</span> eingesetzt.
        </div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 max-width-container">
        <div class="expandable-header">
          <div class="expand-content-left">
            <app-checkbox [checkboxModel]="notwendigModel" [disabled]="true"></app-checkbox>
          </div>
          <div (click)="showNotwendingText.set(!showNotwendingText())" class="expand-icon expand-content-right">
            <div class="material-icons">{{ showNotwendingText() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</div>
          </div>
        </div>
      </div>
      @if (showNotwendingText()) {
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 max-width-container">
          <div>
            Diese Cookies sind für das Funktionieren des Kundenportals erforderlich und können daher nicht deaktiviert
            werden. Sie können jedoch Ihren Browser so einstellen, dass er diese Cookies blockiert oder Sie
            benachrichtigt, aber einige Teile des Kundenportals werden dann nicht mehr vollständig funktionieren. Diese
            Cookies werden ausschließlich von uns verwendet und sind deshalb sogenannte First Party Cookies. Diese
            Cookies speichern keine personenbezogenen Daten.
          </div>
          <div class="content-header bold">reCAPTCHA</div>
          <div>
            Das Kundenportal MEINE NV nutzt in bestimmten Fällen Google
            reCAPTCHA um automatische Programme/Bots an der Nutzung von Textfeldern zu hindern. Dies erhöht die
            Sicherheit des Kundenportals und des SPAM für den User. Dies ist zugleich unser berechtigtes Interesse und
            erfüllt unsere rechtliche Verpflichtung.
          </div>
        </div>
      }
    </div>
  </div>
  <div class="bottom-dialog-buttons">
    <div>
      <koal-button (clickEvent)="dialogRef.close()" leadingIcon="check" text="Akzeptieren"></koal-button>
    </div>
  </div>
</div>
